var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.859 7.74207C12.9144 7.74207 13.2748 8.31334 13.1837 9.10439L12.3204 16.8545C12.2699 17.308 12.5164 17.4773 12.8709 17.1595C13.4273 16.6605 14.147 17.3575 12.9966 18.3911C12.2224 19.0841 11.6462 19.6792 10.6165 19.6415C9.60664 19.6059 9.24626 19.0346 9.33735 18.2436L10.2007 10.4934C10.2512 10.041 10.0037 9.87168 9.6502 10.1875C9.0928 10.6875 8.37402 9.99049 9.52447 8.95786C10.2502 8.30739 10.8026 7.74405 11.859 7.74207ZM11.259 2.87794C12.3303 2.87794 13.2005 3.7472 13.2005 4.82042C13.2005 5.89265 12.3303 6.76192 11.259 6.76192C10.1858 6.76291 9.31557 5.89265 9.31557 4.82042C9.31557 3.7472 10.1858 2.87695 11.259 2.87794ZM11.4838 0.0770721C5.41376 0.0770721 0.491211 4.99863 0.491211 11.0696C0.491211 17.1397 5.41376 22.0622 11.4838 22.0622C17.5558 22.0622 22.4764 17.1397 22.4774 11.0696C22.4764 4.99863 17.5548 0.0770721 11.4838 0.0770721Z",
    fill: "#57E7C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/iIcon.a0260656dd38256d52490fdafcca15e5.svg";
export { ForwardRef as ReactComponent };